
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as mh6Rr4C3smV1bw3mr_2I2rMY7FQIyKpJVaEb3LCEKNq4Meta } from "/nuxtWeb/pages/v/m.vue?macro=true";
import { default as indexs0dizR8Z1uJZRzbKRf4wJpfEab0mFix51iXhKJjApiEMeta } from "/nuxtWeb/pages/index.vue?macro=true";
import { default as loginhV4ttJ10YYb9Ynp67J1kXUuMTzS8V5Pjv5PZbHrl66UMeta } from "/nuxtWeb/pages/login.vue?macro=true";
import { default as indexkikXjWYVB6PqPRmDI4o3eIvrhjD0Os_lZcPPNojniPUMeta } from "/nuxtWeb/pages/v/index.vue?macro=true";
import { default as pcZ_EP__IMET6WcF9Y0WyeJdgG6ruwbQdoEy2_tZEcO28Meta } from "/nuxtWeb/pages/detail/pc.vue?macro=true";
import { default as indexRghymR98fKeSpRh4vH7flLqiNodPDPyOpqEDBXbA_45KYMeta } from "/nuxtWeb/pages/shop/index.vue?macro=true";
import { default as webAZabJredTJt_vlKY3O32hc05T5Cdu3JUXalrcBnTuZYMeta } from "/nuxtWeb/pages/preview/web.vue?macro=true";
import { default as indexf4ew68tovwv_Hp4ndNcnjK3SEjXCed_GVJg002Xb1jEMeta } from "/nuxtWeb/pages/detail/index.vue?macro=true";
import { default as indexqR1iWf7s7bXIgm683mS_45zCyF0HvLSbKde6LLXF9DsHAMeta } from "/nuxtWeb/pages/preview/index.vue?macro=true";
import { default as indexyB1eGXy85Ygs_8WxnvYHj9GYw_S_45CfxC1a6ba2ahpiEMeta } from "/nuxtWeb/pages/product/index.vue?macro=true";
import { default as _91_46_46_46path_9370PuiE8XGLKByJI_tv4_45A7SCimPD4gYDcsLdYSug1owMeta } from "/nuxtWeb/pages/sub/[...path].vue?macro=true";
import { default as indexBKGWIEdAQ73bNySCFth4__45raTaVRaOutFVBxv1ICdRQMeta } from "/nuxtWeb/pages/tb/shop/index.vue?macro=true";
import { default as _91_46_46_46path_93jnqsssuPsAX2_45MbQER1Q2TUSHeeNAHEP05S3KmySEs0Meta } from "/nuxtWeb/pages/mall/[...path].vue?macro=true";
import { default as search2pjgIQ1llPYH9GFL9lXDYDQTBgw8vic_PTWN6JeeiwwMeta } from "/nuxtWeb/pages/product/search.vue?macro=true";
import { default as _91itemId_93L1aNEqSYQ6VmripckK6SlDTJRUS6_45p0zcuUIey9FC2gMeta } from "/nuxtWeb/pages/tb/goods/[itemId].vue?macro=true";
import { default as _91itemId_93viXbpkVrQ6b1nldeMP1OgO5fYYeG_45Z9ZqAtaORg_45dxgMeta } from "/nuxtWeb/pages/wd/goods/[itemId].vue?macro=true";
import { default as _91_46_46_46path_93dnHw9plnR3E15JtAEQzOJMXubbQCK5ubdNpeNxjo5UAMeta } from "/nuxtWeb/pages/collection/[...path].vue?macro=true";
import { default as estimationR09W2qZC55fo_453IEtbXTHBqL6_yNu_45VMHtevbuYVZ9QMeta } from "/nuxtWeb/pages/collection/estimation.vue?macro=true";
import { default as tbPayOrderPqLezfB1U6AbjsdKk8c_45h7vD6eyvaBV2lqmhDKM4MjAMeta } from "/nuxtWeb/pages/user-center/mall/tbPayOrder.vue?macro=true";
import { default as direct_45payment_45confirm95H_O__9XOu8CzlHi7qvwEKndICqV6Z6Sk_45NCA8d2uEMeta } from "/nuxtWeb/pages/tb/order/direct-payment-confirm.vue?macro=true";
import { default as PayWeidianOrderaL1n2KGu1wd9spfhMKXZozLthvHeb5a5bWW2BrQjsYYMeta } from "/nuxtWeb/pages/user-center/mall/PayWeidianOrder.vue?macro=true";
import { default as tbDirectPaymentConfirmNKVSP0NEixxKV6G6I4FBLeUt9NGZ59q_W_jwqy04w1AMeta } from "/nuxtWeb/pages/user-center/mall/tbDirectPaymentConfirm.vue?macro=true";
import { default as Homeyx3yNDTbejMZUCSnDDX4Npvi_AcOQap8mNq1V4ZuHMkMeta } from "/nuxtWeb/user-center/entry/Home.vue?macro=true";
import { default as Page2_457zcb3SGXF_Z8AREhVvq1TgaNvRPUw6ckCSXFK1PdsMeta } from "/nuxtWeb/user-center/entry/Page.vue?macro=true";
export default [
  {
    name: "v-m",
    path: "/v/m",
    component: () => import("/nuxtWeb/pages/v/m.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/nuxtWeb/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhV4ttJ10YYb9Ynp67J1kXUuMTzS8V5Pjv5PZbHrl66UMeta || {},
    component: () => import("/nuxtWeb/pages/login.vue")
  },
  {
    name: "v",
    path: "/v",
    component: () => import("/nuxtWeb/pages/v/index.vue")
  },
  {
    name: "detail-pc",
    path: "/detail/pc",
    component: () => import("/nuxtWeb/pages/detail/pc.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/nuxtWeb/pages/shop/index.vue")
  },
  {
    name: "preview-web",
    path: "/preview/web",
    component: () => import("/nuxtWeb/pages/preview/web.vue")
  },
  {
    name: "detail",
    path: "/detail",
    component: () => import("/nuxtWeb/pages/detail/index.vue")
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/nuxtWeb/pages/preview/index.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/nuxtWeb/pages/product/index.vue")
  },
  {
    name: "sub-path",
    path: "/sub/:path(.*)*",
    meta: _91_46_46_46path_9370PuiE8XGLKByJI_tv4_45A7SCimPD4gYDcsLdYSug1owMeta || {},
    component: () => import("/nuxtWeb/pages/sub/[...path].vue")
  },
  {
    name: "tb-shop",
    path: "/tb/shop",
    component: () => import("/nuxtWeb/pages/tb/shop/index.vue")
  },
  {
    name: "mall-path",
    path: "/mall/:path(.*)*",
    meta: _91_46_46_46path_93jnqsssuPsAX2_45MbQER1Q2TUSHeeNAHEP05S3KmySEs0Meta || {},
    component: () => import("/nuxtWeb/pages/mall/[...path].vue")
  },
  {
    name: "product-search",
    path: "/product/search",
    component: () => import("/nuxtWeb/pages/product/search.vue")
  },
  {
    name: "tb-goods-itemId",
    path: "/tb/goods/:itemId()",
    component: () => import("/nuxtWeb/pages/tb/goods/[itemId].vue")
  },
  {
    name: "wd-goods-itemId",
    path: "/wd/goods/:itemId()",
    component: () => import("/nuxtWeb/pages/wd/goods/[itemId].vue")
  },
  {
    name: "collection-path",
    path: "/collection/:path(.*)*",
    meta: _91_46_46_46path_93dnHw9plnR3E15JtAEQzOJMXubbQCK5ubdNpeNxjo5UAMeta || {},
    component: () => import("/nuxtWeb/pages/collection/[...path].vue")
  },
  {
    name: "collection-estimation",
    path: "/collection/estimation",
    meta: estimationR09W2qZC55fo_453IEtbXTHBqL6_yNu_45VMHtevbuYVZ9QMeta || {},
    component: () => import("/nuxtWeb/pages/collection/estimation.vue")
  },
  {
    name: "user-center-mall-tbPayOrder",
    path: "/user-center/mall/tbPayOrder",
    meta: tbPayOrderPqLezfB1U6AbjsdKk8c_45h7vD6eyvaBV2lqmhDKM4MjAMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/tbPayOrder.vue")
  },
  {
    name: "tb-order-direct-payment-confirm",
    path: "/tb/order/direct-payment-confirm",
    component: () => import("/nuxtWeb/pages/tb/order/direct-payment-confirm.vue")
  },
  {
    name: "user-center-mall-PayWeidianOrder",
    path: "/user-center/mall/PayWeidianOrder",
    meta: PayWeidianOrderaL1n2KGu1wd9spfhMKXZozLthvHeb5a5bWW2BrQjsYYMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/PayWeidianOrder.vue")
  },
  {
    name: "user-center-mall-tbDirectPaymentConfirm",
    path: "/user-center/mall/tbDirectPaymentConfirm",
    meta: tbDirectPaymentConfirmNKVSP0NEixxKV6G6I4FBLeUt9NGZ59q_W_jwqy04w1AMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/tbDirectPaymentConfirm.vue")
  },
  {
    name: "userCenterRoot",
    path: "/user-center",
    meta: Homeyx3yNDTbejMZUCSnDDX4Npvi_AcOQap8mNq1V4ZuHMkMeta || {},
    component: () => import("/nuxtWeb/user-center/entry/Home.vue")
  },
  {
    name: "UserCenterLogin",
    path: "/user-center/login",
    meta: { ...(Page2_457zcb3SGXF_Z8AREhVvq1TgaNvRPUw6ckCSXFK1PdsMeta || {}), ...{"userCenterViewKey":"login","userCenterStandalone":true,"requiresUserCenterAuth":false,"title":"登录","pageTitle":"登录"} },
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallHome",
    path: "/user-center/mall/home",
    meta: {"userCenterViewKey":"mallHome","requiresUserCenterAuth":true,"code":"mallHome","title":"首页","pageTitle":"首页"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAllOrderList",
    path: "/user-center/mall/allOrderList",
    meta: {"userCenterViewKey":"mallAllOrderList","requiresUserCenterAuth":true,"code":"mallAllOrderList","title":"全部订单","pageTitle":"全部订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallSelectOrderList",
    path: "/user-center/mall/selectOrderList",
    meta: {"userCenterViewKey":"mallSelectOrderList","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallSelectOrderList","title":"全部订单","pageTitle":"全部订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallWarehousePackage",
    path: "/user-center/mall/warehousePackage",
    meta: {"userCenterViewKey":"mallWarehousePackage","requiresUserCenterAuth":true,"code":"mallWarehousePackage","title":"仓库包裹","pageTitle":"仓库包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallFavorites",
    path: "/user-center/mall/favorites",
    meta: {"userCenterViewKey":"mallFavorites","requiresUserCenterAuth":true,"code":"mallFavorites","title":"收藏夹","pageTitle":"收藏夹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAccount",
    path: "/user-center/mall/account",
    meta: {"userCenterViewKey":"mallAccount","requiresUserCenterAuth":true,"code":"mallAccount","title":"会员中心","pageTitle":"会员中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallMessage",
    path: "/user-center/mall/message",
    meta: {"userCenterViewKey":"mallMessage","requiresUserCenterAuth":true,"code":"mallMessage","title":"消息中心","pageTitle":"消息中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAllOrderDetail",
    path: "/user-center/mall/allOrderDetail",
    meta: {"userCenterViewKey":"mallAllOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallAllOrderDetail","title":"订单详情","pageTitle":"订单详情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbOrderDetail",
    path: "/user-center/mall/tbOrderDetail",
    meta: {"userCenterViewKey":"mallTbOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbOrderDetail","title":"订单详情","pageTitle":"订单详情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallWeidianOrderDetail",
    path: "/user-center/mall/weidianOrderDetail",
    meta: {"userCenterViewKey":"mallWeidianOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallWeidianOrderDetail","title":"订单详情","pageTitle":"订单详情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallCart",
    path: "/user-center/mall/cart",
    meta: {"userCenterViewKey":"mallCart","requiresUserCenterAuth":true,"code":"mallCart","title":"购物车","pageTitle":"购物车"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallConfirmation1688Order",
    path: "/user-center/mall/confirmation1688Order",
    meta: {"userCenterViewKey":"mallConfirmation1688Order","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallConfirmation1688Order","title":"确认订单","pageTitle":"确认订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallConfirmationWeidianOrder",
    path: "/user-center/mall/confirmationWeidianOrder",
    meta: {"userCenterViewKey":"mallConfirmationWeidianOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallConfirmationWeidianOrder","title":"确认订单","pageTitle":"确认订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPay1688Order",
    path: "/user-center/mall/Pay1688Order",
    meta: {"userCenterViewKey":"mallPay1688Order","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallPay1688Order","title":"支付订单","pageTitle":"支付订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPayWeidianOrder",
    path: "/user-center/mall/PayWeidianOrder",
    meta: {"userCenterViewKey":"mallPayWeidianOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallPayWeidianOrder","title":"支付订单","pageTitle":"支付订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbDirectPaymentConfirm",
    path: "/user-center/mall/tbDirectPaymentConfirm",
    meta: {"userCenterViewKey":"mallTbDirectPaymentConfirm","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbDirectPaymentConfirm","title":"确认订单","pageTitle":"确认订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbPayOrder",
    path: "/user-center/mall/tbPayOrder",
    meta: {"userCenterViewKey":"mallTbPayOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbPayOrder","title":"支付订单","pageTitle":"支付订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mall1688Recharge",
    path: "/user-center/mall/recharge",
    meta: {"userCenterViewKey":"mallRecharge","requiresUserCenterAuth":true,"code":"mall1688Recharge","title":"余额充值","pageTitle":"余额充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPackage",
    path: "/user-center/collection/mallPackage",
    meta: {"userCenterViewKey":"collectionMallPackage","requiresUserCenterAuth":true,"code":"mallPackage","title":"电商包裹","pageTitle":"电商包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionHome",
    path: "/user-center/collection/home",
    meta: {"userCenterViewKey":"collectionHome","requiresUserCenterAuth":true,"code":"collectionHome","title":"首页","pageTitle":"首页"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionOrder",
    path: "/user-center/collection/order",
    meta: {"userCenterViewKey":"collectionOrder","requiresUserCenterAuth":true,"code":"collectionOrder","title":"集运订单","pageTitle":"集运订单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPackage",
    path: "/user-center/collection/package",
    meta: {"userCenterViewKey":"collectionPackage","requiresUserCenterAuth":true,"code":"collectionPackage","title":"集运包裹","pageTitle":"集运包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionForecast",
    path: "/user-center/collection/forecast",
    meta: {"userCenterViewKey":"collectionForecast","requiresUserCenterAuth":true,"code":"collectionForecast","title":"申请预报","pageTitle":"申请预报"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionIncome",
    path: "/user-center/collection/income",
    meta: {"userCenterViewKey":"collectionIncome","requiresUserCenterAuth":true,"code":"collectionIncome","title":"消费流水","pageTitle":"消费流水"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionAddress",
    path: "/user-center/collection/address",
    meta: {"userCenterViewKey":"collectionAddress","requiresUserCenterAuth":true,"code":"collectionAddress","title":"收货地址","pageTitle":"收货地址"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionInvite",
    path: "/user-center/collection/invite",
    meta: {"userCenterViewKey":"collectionInvite","requiresUserCenterAuth":true,"code":"collectionInvite","title":"赚取积分","pageTitle":"赚取积分"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "FindLogistics",
    path: "/user-center/collection/findLogistics",
    meta: {"userCenterViewKey":"collectionFindLogistics","requiresUserCenterAuth":true,"code":"FindLogistics","title":"物流查询","pageTitle":"物流查询"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionRechargeWallet",
    path: "/user-center/collection/rechargeWallet",
    meta: {"userCenterViewKey":"collectionRechargeWallet","requiresUserCenterAuth":true,"code":"collectionRechargeWallet","title":"快捷充值","pageTitle":"快捷充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionRecharge",
    path: "/user-center/collection/recharge",
    meta: {"userCenterViewKey":"collectionRecharge","requiresUserCenterAuth":true,"code":"collectionRecharge","title":"快捷充值","pageTitle":"快捷充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionCoupons",
    path: "/user-center/collection/coupons",
    meta: {"userCenterViewKey":"collectionCoupons","requiresUserCenterAuth":true,"code":"collectionCoupons","title":"优惠券","pageTitle":"优惠券"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPoints",
    path: "/user-center/collection/points",
    meta: {"userCenterViewKey":"collectionPoints","requiresUserCenterAuth":true,"code":"collectionPoints","title":"积分","pageTitle":"积分"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPayOrder",
    path: "/user-center/collection/payOrder",
    meta: {"userCenterViewKey":"collectionPayOrder","requiresUserCenterAuth":true,"code":"collectionPayOrder","title":"应付账单","pageTitle":"应付账单"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionDeclaration",
    path: "/user-center/collection/declaration",
    meta: {"userCenterViewKey":"collectionDeclaration","requiresUserCenterAuth":true,"code":"collectionDeclaration","title":"发起集运","pageTitle":"发起集运"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionProxy",
    path: "/user-center/collection/proxy",
    meta: {"userCenterViewKey":"collectionProxy","requiresUserCenterAuth":true,"code":"collectionProxy","title":"代理中心","pageTitle":"代理中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "WithdrawCash",
    path: "/user-center/collection/withdrawCash",
    meta: {"userCenterViewKey":"collectionWithdrawCash","requiresUserCenterAuth":true,"code":"withdrawCash","title":"代理提现","pageTitle":"代理提现"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionReturnPackage",
    path: "/user-center/collection/ReturnPackage",
    meta: {"userCenterViewKey":"collectionReturnPackage","requiresUserCenterAuth":true,"title":"退货包裹","pageTitle":"退货包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  }
]